import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ShoppingBag } from "lucide-react";
import { useCart } from "@/context/CartContext";
import { scrollToId } from "@/utils/scroll";

export default function Nav() {
  const { count, setDrawerOpen } = useCart();
  const [scrolled, setScrolled] = useState(false);
  const navigate = useNavigate();
  const { pathname } = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const goHome = () => {
    if (pathname !== "/") navigate("/");
    else scrollToId(0);
  };

  return (
    <header
      data-testid="main-nav"
      className={`fixed inset-x-0 top-0 z-50 transition-colors duration-500 ${
        scrolled ? "bg-black/75 backdrop-blur-md border-b border-white/10" : ""
      }`}
    >
      <nav className="flex items-center justify-between px-5 sm:px-8 py-4">
        <button
          data-testid="nav-logo"
          onClick={goHome}
          className="font-display text-paper text-sm sm:text-base tracking-[0.25em] hover:text-pink transition-colors py-3 -my-3"
        >
          SHUTUP STUDIO
        </button>
        <div className="flex items-center gap-4 sm:gap-6">
          <button
            data-testid="nav-cart-button"
            onClick={() => setDrawerOpen(true)}
            aria-label={`Cart, ${count} items`}
            className="relative flex items-center justify-center min-w-[44px] min-h-[44px] -m-2 text-paper hover:text-turq transition-colors"
          >
            <ShoppingBag className="w-5 h-5 sm:w-6 sm:h-6" strokeWidth={2.2} />
            {count > 0 && (
              <span
                data-testid="nav-cart-count"
                className="absolute -top-2 -right-2.5 min-w-[18px] h-[18px] px-1 flex items-center justify-center bg-pink text-black font-sans text-[10px] font-bold rounded-full"
              >
                {count}
              </span>
            )}
          </button>
          <button
            data-testid="nav-buy-now"
            data-cursor="shutup"
            onClick={() => navigate("/product")}
            className="font-sans bg-pink text-black text-xs sm:text-sm font-bold tracking-[0.15em] px-4 py-3 hover:bg-acid transition-colors"
          >
            BUY NOW
          </button>
        </div>
      </nav>
    </header>
  );
}
